import ChatStrategy from './ChatStrategy';

export default class WorkOrderListStrategy extends ChatStrategy {
  constructor() {
    super();
    this.retryMessages = [
      'Searching for relevant information...',
      'Processing your query...',
      'Analyzing work orders...',
      'Retrieving data from the knowledge base...',
      'Let me check that for you...',
    ];
    this.type = 'workorderlist';
  }

  // eslint-disable-next-line no-unused-vars
  getIdentity(metadata) {
    return 'workorderlist';
  }

  getStrategyTitle() {
    return 'Repair Select Assistant';
  }

  getInitialMessage() {
    return 'What can I help you with today?';
  }

  shouldAutoSubmit() {
    return false;
  }

  createPayload(chatId, metadata, interactions) {
    let appLocation = window.location.href;
    if (appLocation.includes('localhost')) {
      appLocation = appLocation.replace(
        window.location.origin,
        'https://dij.mosaic-qa.siemens-energy.cloud'
      );
    }
    const interactionType = this.determineInteractionType(appLocation);

    return {
      providedId: chatId,
      requestType: 'chatbot',
      appLocation,
      interactionType,
      interactionData: interactions,
    };
  }

  determineInteractionType(url) {
    if (url.includes('/editor')) return 'editor';
    if (url.includes('/inspector')) return 'inspector';
    if (url.includes('/publisher')) return 'publisher';
    if (url.includes('/report')) return 'report';
    return 'unknown';
  }

  parseUserMessage() {
    // Return null to avoid echoing the user message as a system message
    return null;
  }

  onMessageReceived(event) {
    let data = event;

    // Check if we have a stringified event payload
    if (data.event && typeof data.event === 'string') {
      try {
        const parsed = JSON.parse(data.event);
        data = { ...data, ...parsed };
      } catch (e) {
        console.error('Failed to parse event data', e);
      }
    }

    if (data.error) {
      console.error(data.error);
      return {
        text: 'Something went wrong. Please try again later.',
        isError: true,
      };
    }

    if (data.status_code === 500) {
      return {
        text: 'An error has occurred. Please try again later.',
        isError: true,
      };
    }

    if (data.status_code !== 200) {
      return {
        text: 'Unable to process your request at this time.',
        isError: true,
      };
    }

    // Parse the response
    let response = '';
    let documents = [];

    try {
      // If the result is JSON, try to parse it
      if (
        typeof data.result === 'string' &&
        data.result.trim().startsWith('{')
      ) {
        const parsed = JSON.parse(data.result);
        response = parsed.response || data.result;
        documents = parsed.documents || [];
      } else {
        response = data.result;
      }
    } catch (error) {
      // If parsing fails, use the result as-is
      response = data.result;
    }

    return {
      text: response || '',
      documents: documents || [],
      isError: false,
    };
  }
}
